import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import { RequireAuth } from "../contexts/User";

import App from "../App";

import Login from "../pages/auth/Login/index";

import ResetPassword from "../pages/auth/ResetPassword/index";

import MainScreen from "../pages/MissionControl/MainScreen/index.js";

import DataAnalytics, {
  loader as dataAnalyticsLoader,
} from "../pages/Configure/DataAnalytics/index.tsx";

import CreateNotificationConfigurations, {
  loader as createNotificationConfigurationsLoader,
} from "../pages/MissionControl/NotificationConfigurations/Create/index";
import ManageNotificationConfigurations, {
  loader as manageNotificationConfigurationsLoader,
} from "../pages/MissionControl/NotificationConfigurations/Manage/index";

import ViewAlerts, {
  loader as viewAlertsLoader,
} from "../pages/MissionControl/ViewAlerts/index";

import MapView, {
  loader as mapViewLoader,
} from "../pages/MissionControl/MapView";

import TestMap from "../pages/temp/TestMap/index.tsx";

import Dashboard, {
  loader as dashboardLoader,
} from "../pages/MissionControl/Dashboard/index.js";

import ConfiguredMetadata from "../pages/Configure/Metadata/ConfiguredMetadata";

import PaymentProcessing from "../pages/Accounts/PaymentProcessing/PaymentProcessing";

import Summary from "../pages/Dashboard/Summary/Summary";

import Technical from "../pages/Technical/index.jsx";

import Policies from "../pages/Configure/Policies";

import UserProfilePage, {
  loader as userProfilePageLoader,
} from "../pages/Profile/UserProfile/index.js";
import ProfileInfo from "../pages/Profile/UserProfile/ProfileInfo/index.js";
import SecuritySettings from "../pages/Profile/UserProfile/SecuritySettings/index.js";
import AdminSettings from "../pages/Profile/UserProfile/AdminSettings/index.js";

import NoMatch from "../pages/NoMatch/index";

// Temp pages for demo purposes
// TODO: Remove when needed no longer
import Maximo from "../pages/Demo/Maximo/index.tsx";
import PowerBi from "../pages/Demo/PowerBi/index.tsx";
import CyberSecurityPlatform from "../pages/Demo/TempCyberSecurityPlatform/index.tsx";

export const routeElements = (
  <Route path="/" element={<App />}>
    {/* Public/Pre-Auth Routes */}
    <Route path="login" element={<Login />} />

    <Route path="reset-password" element={<ResetPassword />} />

    {/* Private/Authorized Routes */}
    <Route element={<RequireAuth />}>
      <Route path="main-display" element={<MainScreen />} />

      <Route
        path="dashboard"
        loader={() => dashboardLoader()}
        element={<Dashboard />}
      />

      <Route
        path="console-view"
        loader={() => mapViewLoader()}
        element={<MapView />}
      />

      <Route path="notification-configurations">
        <Route
          path="create"
          loader={() => createNotificationConfigurationsLoader()}
          element={<CreateNotificationConfigurations />}
        />
        <Route
          path="manage"
          loader={() => manageNotificationConfigurationsLoader()}
          element={<ManageNotificationConfigurations />}
        />
      </Route>

      <Route
        path="view-alerts"
        loader={() => viewAlertsLoader()}
        element={<ViewAlerts />}
      />

      <Route
        path="data-analytics"
        loader={() => dataAnalyticsLoader()}
        element={<DataAnalytics />}
      />

      <Route path="configured-metadata" element={<ConfiguredMetadata />} />

      <Route
        path="/accounts/payment-processing"
        element={<PaymentProcessing />}
      />

      <Route path="/summary" element={<Summary />} />

      <Route path="/technical" element={<Technical />} />

      <Route path="policies" element={<Policies />} />

      <Route
        path="profile"
        loader={() => userProfilePageLoader()}
        element={<UserProfilePage />}
      >
        <Route path="information" element={<ProfileInfo />} />
        <Route path="security" element={<SecuritySettings />} />
        <Route path="administrator-settings" element={<AdminSettings />} />
      </Route>

      {/* Temp pages for demo purposes */}
      <Route path="maximo" element={<Maximo />} />
      <Route path="power-bi" element={<PowerBi />} />
      <Route
        path="cyber-security-platform"
        element={<CyberSecurityPlatform />}
      />
      <Route path="dev-test-map" element={<TestMap />} />
      {/* End temp pages */}
    </Route>

    {/* No Match page */}
    <Route path="*" element={<NoMatch />} />
  </Route>
);

const router = createBrowserRouter(createRoutesFromElements(routeElements));

export default router;
